import React from 'react';
import {ProspectPool} from 'api';
import {ScoreHistoryItem} from './ScoreHistoryItem';

interface Props {
  prospectPool: ProspectPool;
}

export default ({prospectPool}: Props) => {
  const histories = prospectPool?.prospectPoolTotalScoreRankHistories || [];

  if (histories.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-y-auto">
        {histories.map((history) => (
          <ScoreHistoryItem key={history.id} history={history} />
        ))}
      </div>
    </div>
  );
};
